module.exports = __webpack_public_path__ + "static/media/new3.9ea84479.jpg";